import { Link, useNavigate } from "react-router-dom";
import iconNotice from "../images/icon_notice.png";
import myBtnMb from "../images/my_btn_mb.png";
import readyImg from "../images/ready-img.png";
import logo from "../images/(관리CI) 알엠테크솔루션_CI(배경 삭제).png";
import { useEffect, useState } from "react";
import * as accountApi from "../apis/AccountApi";
import {
  deleteToken,
  setTokenInLocal,
  setTokenInSession,
  updateTokenInSession,
  useAppContext,
} from "utils/store";
import { apiWrapper } from "apis/CommonApi";
import * as mainApi from "../apis/MainApi";
import {
  getStatusClassName,
  getStatusColorClassName,
  getStatusName,
  getUserAuthorityName,
  UserAuthorityChoice,
} from "utils/common";
import useInterval from "utils/useInterval";
import { getDateTime } from "utils/date";

export default function LoginPage() {
  const [isReadyModalVisible, setReadyModalVisible] = useState(false);

  const showReadyModal = () => {
    setReadyModalVisible(true);
  };

  const closeReadyModal = () => {
    setReadyModalVisible(false);
  };

  return (
    <div id="wrap">
      <main id="main" className="main">
        <HeadSection />
        <NoticeViewSection />
        <ControlSection showReadyModal={showReadyModal} />
        {isReadyModalVisible && (
          <ReadyModal closeReadyModal={closeReadyModal} />
        )}
      </main>
    </div>
  );
}

const HeadSection = () => (
  <section className="headSection">
    <div className="container">
      <div className="wrap_head">
        <div className="wrap_title">
          <img src={logo} style={{ maxWidth: "250px" }} />
          <span className="bar"></span>
          <p className="title">스마트 AIoT 화재 모니터링 시스템</p>
        </div>
        <div className="wrap_info">
          <p className="txt_info mail_info">
            메일 : rmtech@rmtechsolution.co.kr
          </p>
          <span className="bar"></span>
          <p className="txt_info tel_info">전화 : 070-7780-3056</p>
        </div>
      </div>
    </div>
  </section>
);

const NoticeViewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    apiWrapper(async () => {
      const result = await mainApi.getNoticePostList();
      const { status, data } = result;
      if (status === true) {
        setDataSource(data);
      }
    });
  }, []);

  useInterval(() => {
    if (dataSource) {
      setCurrentIndex((prevIndex) => {
        return (prevIndex + 1) % dataSource.length;
      });
    }
  }, 5000);

  return (
    <section className="noticeVeiwSection">
      <div className="container">
        <div className="board_notice">
          <div className="wrap_notice">
            <img className="icon_notice" src={iconNotice} alt="공지사항 알림" />
            {dataSource[currentIndex] && (
              <p className="title_notice">{dataSource[currentIndex].title}</p>
            )}
          </div>
          <Link className="btn_link btn_notice pc" to="/board/system">
            공지사항
            <i className="x-icon btn_icon"></i>
          </Link>
          <Link className="btn_link btn_notice mb" to="/board/system">
            <i className="x-icon btn_icon"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

const ControlSection = ({ showReadyModal }) => {
  return (
    <>
      <section className="controllSection">
        <div className="container">
          <div className="board-inner_wrap">
            <BoardMenu showReadyModal={showReadyModal} />
            <UserBoard />
          </div>
          <PolicySection />
        </div>
      </section>
    </>
  );
};

const BoardMenu = ({ showReadyModal }) => {
  const { store, dispatch } = useAppContext();
  const {
    store: { userId, userAuthority },
  } = useAppContext();

  return (
    <div className="board_menu">
      <MenuItem
        onClick={showReadyModal}
        title={"시스템 소개\n(사용 매뉴얼)"}
        itemName="item_1"
        iconName="icon_1"
      />
      <MenuItem
        onClick={showReadyModal}
        title="시스템 문의"
        itemName="item_3"
        iconName="icon_1"
      />
      {userId && (
        <MenuItem
          linkTo={"/fire-on/"}
          title="Fire-On"
          itemName="item_2"
          iconName="icon_2"
        />
      )}
      <MenuItem
        onClick={showReadyModal}
        title={"소방시설공사\n견적문의"}
        itemName="item_4"
        iconName="icon_2"
      />
      <MenuItem
        onClick={showReadyModal}
        title={"소방시설점검\n견적문의"}
        itemName="item_5"
        iconName="icon_2"
      />
      {(userAuthority === UserAuthorityChoice.ADMIN ||
        userAuthority === UserAuthorityChoice.BUSINESS) && (
          <MenuItem
            linkTo={"/dbms/fire-receiver/management"}
            title="시스템 DBMS"
            itemName="item_6"
            iconName="icon_2"
          />
        )}
    </div>
  );
};

const MenuItem = ({ linkTo, onClick, title, itemName, iconName }) => (
  <Link className={`item_menu ${itemName}`} to={linkTo} onClick={onClick}>
    <p className="title_menu">{title}</p>
    <div className="icon_menu">
      <i className={`x-icon ${iconName}`}></i>
    </div>
  </Link>
);

function UserBoard() {
  const navigate = useNavigate();
  const { store, dispatch } = useAppContext();
  const [isLoginResultModalVisible, setLoginResultModalVisible] =
    useState(false);
  const [formData, setFormData] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const {
    store: { userId, userName, userAuthority },
  } = useAppContext();
  const isLogin = userId !== "";

  useEffect(() => {
    setFormDataProperty("userId", "");
    setFormDataProperty("password", "");
    setFormDataProperty("isAutoLogin", false);

    if (isLogin) {
      handleReload();
    }
  }, []);

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = {
          userId: formData.userId,
          password: formData.password,
        };

        const { status, data } = await accountApi.login(requestBody);
        if (status === false) {
          alert(`${data}`);
          // setLoginResultModalVisible(true);
          // setTimeout(() => {
          //   setLoginResultModalVisible(false);
          // }, 3000);
        } else {
          const { refresh, access, user } = data;
          const { userId, isAutoLogin } = formData;
          if (isAutoLogin) {
            //자동로그인일 때는 로컬스토리지에 저장
            dispatch(
              setTokenInLocal(
                access,
                refresh,
                user.id,
                userId,
                user.userName,
                user.userAuthority,
                completedCallback
              )
            );
          } else {
            //아닐 때는 세션스토리지에 저장
            dispatch(
              setTokenInSession(
                access,
                refresh,
                user.id,
                userId,
                user.userName,
                user.userAuthority,
                completedCallback
              )
            );
          }
        }
      });
    }
  };

  const completedCallback = () => {
    handleReload();
  };

  const handleReload = () => {
    apiWrapper(async () => {
      const { status, data } = await mainApi.getDashboardList();
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleLogout = () => {
    if (window.confirm("로그아웃하시겠습니까?")) {
      dispatch(deleteToken());
      //navigate("/");
    }
  };

  const handleChangeAutoLogin = (e) => {
    setFormDataProperty("isAutoLogin", e.target.checked);
  };

  return (
    <>
      <div className="board_user">
        {isLogin === false ? (
          //로그인 전
          <form onSubmit={handleLogin}>
            <div className="board_login">
              <div className="top_login">
                <p className="title_login">
                  스마트 AIoT <br /> 화재 모니터링 시스템
                </p>
                <Link className="btn_link btn_support" to="">
                  고객센터
                  <i className="x-icon btn_icon"></i>
                </Link>
              </div>
              {formData && (
                <div className="mid_login">
                  <div className="wrap_input">
                    <input
                      type="text"
                      className="defaultInput"
                      name="userId"
                      value={formData.userId}
                      onChange={onChange}
                      required="required"
                    />
                    <input
                      type="password"
                      className="defaultInput"
                      name="password"
                      value={formData.password}
                      onChange={onChange}
                      required="required"
                    />
                  </div>
                  <div className="wrap_find">
                    <label htmlFor="check_1" className="checked-item">
                      <input
                        type="checkbox"
                        id="check_1"
                        className="form-checkbox"
                        checked={formData.isAutoLogin}
                        onChange={handleChangeAutoLogin}
                      />
                      <span className="check-icon">
                        <i className="xi-check"></i>
                      </span>
                      <p className="check-title">자동 로그인</p>
                    </label>
                    <div className="link_find">
                      <Link className="btn_find" to="/find-id/">
                        아이디 찾기
                      </Link>
                      <span className="bar"></span>
                      <Link className="btn_find" to="/find-password/">
                        비밀번호 찾기
                      </Link>
                    </div>
                  </div>
                </div>
              )}
              <div className="btm_login">
                <button className="login" type="submit">
                  로그인
                </button>
                <Link className="btn_join" to="/join/">
                  회원가입
                </Link>
              </div>
            </div>
          </form>
        ) : (
          //로그인 후
          <div className="board_myInfo">
            <div className="top_myInfo">
              <div className="wrap_name">
                <p className="title_name">
                  {getUserAuthorityName(userAuthority)}
                </p>
                <p className="sub_name">{userName}님 환영합니다.</p>
              </div>
              <div className="wrap_stateBtn">
                <Link
                  className="btn_state btn_setting pc"
                  to="/user-account/"
                  title="회원정보"
                >
                  <i className="x-icon state_icon"></i>
                </Link>
                <button
                  className="btn_state btn_logout pc"
                  title="로그아웃"
                  onClick={handleLogout}
                >
                  <i className="x-icon state_icon"></i>
                </button>
                <Link
                  className="btn_state btn_withdraw pc"
                  to="/withdraw/"
                  title="회원탈퇴"
                >
                  <i className="x-icon state_icon"></i>
                </Link>
                <button className="btn_state mb">
                  <img src={myBtnMb} alt="" />
                </button>
              </div>
            </div>
            {dataSource && (
              <div className="list_myInfo">
                <div className="top_list">
                  <div className="wrap_total">
                    <p className="txt_total">Fire-On</p>
                    <span className="bar"></span>
                    <p className="title_total">
                      전체 {dataSource.totalCount}개소
                    </p>
                  </div>
                  <div className="wrap_reroad">
                    <p className="txt_reroad date_reroad">
                      {getDateTime(new Date(dataSource.queryTime))}
                    </p>
                    <button className="btn_reroad" onClick={handleReload}>
                      <i className="x-icon"></i>
                    </button>
                  </div>
                </div>
                <div className="wrap_list">
                  {/* 상태별 아이템 목록 */}
                  {dataSource.fireList.length > 0 &&
                    dataSource.fireList.map((item, index) => (
                      <ListItem key={index} item={item} />
                    ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {isLoginResultModalVisible && <LoginResultModal />}
    </>
  );
}

const ListItem = ({ item }) => (
  <div className={`item_list ${getStatusClassName(item.status)}`}>
    <div className="wrap_title_item">
      <p className="title_item">{item.name}</p>
    </div>
    <div className="wrap_state_item">
      <div
        className={`cir_state ${getStatusColorClassName(item.status)}`}
      ></div>
      <p className="title_state">{getStatusName(item.status)}</p>
    </div>
  </div>
);

const PolicySection = () => (
  <div className="container policyContainer">
    <div className="wrap_policy">
      <Link className="btn_policy" to="">
        회사소개
      </Link>
      <span className="bar"></span>
      <Link className="btn_policy" to="">
        고객센터
      </Link>
      <span className="bar"></span>
      <Link className="btn_policy" to="">
        화재정보 API
      </Link>
      <span className="bar"></span>
      <Link className="btn_policy" to="">
        제휴광고문의
      </Link>
    </div>
    <div className="wrap_copy">
      <div className="item_copy">
        <p className="title_copy">주소</p>
        <p className="title_cont">
          경기도 안양시 동안구 엘에스로116번길 91, <br className="mb" />{" "}
          금정역3차SKV1센터 403호
        </p>
      </div>
      <div className="item_copy">
        <p className="title_copy">사업자</p>
        <div className="wrap_cont">
          <p className="title_cont">사업자번호 : 143-81-34432</p>
          <p className="title_cont">대표 이사 : 김진석</p>
        </div>
      </div>
      <p className="txt_copy">
        COPYRIGHT RMTECHSOLUTION.CO.,LTD. ALL RIGHTS RESERVED
      </p>
    </div>
  </div>
);

const ReadyModal = ({ closeReadyModal }) => (
  <div className="modal-overlay ready-modal" style={{ display: "flex" }}>
    <div className="modal-content ready-modal-content">
      <button className="modal-close-btn" onClick={closeReadyModal}>
        <i className="x-icon"></i>
      </button>
      <img src={readyImg} alt="준비중 이미지" className="ready-img" />
      <p className="ready-title">
        현재 페이지는
        <br />
        준비중입니다.
      </p>
      <p className="ready-subtext">
        현재 페이지는 더욱 좋은 모습을 선보이기 위해 준비 중입니다. <br />
        빠른 시일 내에 업데이트하여 찾아뵙겠습니다.
      </p>
    </div>
  </div>
);

const LoginResultModal = () => (
  <div class="modal-overlay show">
    <div class="modal-content infoResultModal">
      <div class="modal_inner">
        <p class="title_cont">
          회원정보가 올바르지 않습니다. <br />
          다시 한번 확인해주세요.
        </p>
      </div>
    </div>
  </div>
);
